import {SET_DESTINATION_URGENCY_MESSAGE} from '../../actions/action-types';
import {TEMPLATE_ID_HEADER, BOT_HEADER} from '../../utils/constants';

// Actions
export const setUrgencyDestinationMessage = (result) => {
    const {
        iconTitleTextMessageData: iconTitleText = null,
        iconTextMessageData: iconText = null,
        type,
    } = result;

    return {
        type: SET_DESTINATION_URGENCY_MESSAGE,
        payload: {
            iconTitleText,
            iconText,
            type,
        },
    };
};

export const fetchUrgencyDestinationMessage = ({
    arrival,
    basePathPrefix,
    departure,
    geographyName,
    geographyUuid,
    locale,
}) => {
    return (dispatch, getState) => {
        const {
            config: {
                template,
                context: {isBot},
            },
        } = getState();
        const query = {
            geographyName,
            geographyUuid,
            locale,
        };

        if (arrival && departure) {
            query.arrival = arrival;
            query.departure = departure;
        }

        const requestUrl = `${basePathPrefix}/api/urgencyMessageService/destinationMessage?${new URLSearchParams(
            query
        ).toString()}`;

        return fetch(requestUrl, {
            credentials: 'same-origin',
            headers: {
                [TEMPLATE_ID_HEADER]: template,
                [BOT_HEADER]: isBot,
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(
                        'Failed loading destination urgency messages'
                    );
                }
                return res.json();
            })
            .then((message) => dispatch(setUrgencyDestinationMessage(message)))
            .catch((err) => {
                dispatch(setUrgencyDestinationMessage({type: 'error'}));
                console.log(err); // eslint-disable-line
            });
    };
};

// Reducers
export default (state = {}, action) => {
    switch (action.type) {
        case SET_DESTINATION_URGENCY_MESSAGE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
